import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'core-block-related-benefits',
    templateUrl: './block-related-benefits.component.html',
})

export class BlockRelatedBenefitsComponent extends BlockAbstractComponent implements OnInit {

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected router: Router,
    ) {
        super(
            parser,
            auth
        );
    }

    navigateToPage(link: string) {
        if (link.indexOf('#') > -1) {
            // Contains HASH!
            const urlArray = link.split('#');
            this.router.navigate( [urlArray[0]], {fragment: urlArray[1]});
        } else {
            // No Hash, proceed as usual
            this.router.navigate([link]);
        }
    }
}
